import PitchCall from "../../enums/PitchCall.js";

// @see https://www.mlb.com/glossary/rules/balk
// A balk occurs when a pitcher makes an illegal motion on the mound that the umpire deems to be deceitful to the runner(s). As a result, any men on base are awarded the next base, and the pitch (if it was thrown in the first place) is waved off for a dead ball.
const classifiesAsBalk = function(pitchCall) {
    switch (pitchCall) {
        case PitchCall.Balk.key:
            return true;

        default:
            return false;
    }
};


export default classifiesAsBalk;